import { render } from "./AdminEditPost.vue?vue&type=template&id=95bbee1a"
import script from "./AdminEditPost.vue?vue&type=script&lang=js"
export * from "./AdminEditPost.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mohamedyousef/projects/online_education/projects/web-applications/admin-panel-for-education-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__